<template>
    <div>
        <div @mouseleave="showEdit = false" @mousemove="showEdit = true">
            <el-link @click="editTag">{{ data }}</el-link>
            <el-tooltip class="item" effect="dark" :content="row.describe" placement="bottom">
                <i v-show="showEdit" class="el-icon-warning-outline"></i>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import TagModal from "../components/TagModal.vue";

export default {
    name: "TagName",
    props: ["data", "row"],
    computed: {},
    data() {
        return {
            showEdit: false,
        }
    },
    methods: {
        editParamsHandle() {
            this.$emit("click");
        },
        editTag() {
            const { id, classify_id, name, describe, param_json } = this.row;
            // 编辑画像标签
            this.$store.dispatch("zhiji/showModal", {
                type: TagModal,
                data: {
                    title: "编辑参数封装标签",
                    id,
                    classOptions: this.classOptions, // 标签分类下拉项
                    classId: classify_id.toString(), // 选中标签分类
                    name,
                    describe,
                    paramJson: param_json,
                    submit: async () => {
                        // 
                        this.$emit("click", "successEdit");
                    }
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
.el-icon-warning-outline {
    margin: 0 5px 0 5px;
    vertical-align: -2px;
    font-size: 16px;
    color: #b0b8c4;
}
</style>